module.exports = __webpack_public_path__ + "7ac92d36cc27baaece36e1e0beaecc93.svg";